import { render, staticRenderFns } from "./AutoBackups.vue?vue&type=template&id=58a47780"
import script from "./AutoBackups.vue?vue&type=script&lang=js"
export * from "./AutoBackups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports